export default "__VITE_ASSET__p8yUBpg0__"